(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-ar-cta"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-ar-cta')) {
    customElements.define(
      'product-ar-cta',
      class ProductARCTA extends HTMLElement {
        connectedCallback() {
          this.events?.abort();
          this.events = new AbortController();
          this.pending = false;
          this.requestNumber = (this.requestNumber || 0) + 1;
          this.querySelectorAll('[data-product-3d-open]').forEach((button) => {
            button.addEventListener('click', () => this.openModel(), { signal: this.events.signal });
          });
          this.setupXR = () => {
            if (window.ShopifyXR && window.ProductModel?.setupShopifyXR) {
              window.ProductModel.setupShopifyXR();
            } else if (window.ShopifyXR?.setupXRElements) {
              window.ShopifyXR.setupXRElements();
            }
          };
          document.addEventListener('shopify_xr_initialized', this.setupXR, { signal: this.events.signal });
          document.addEventListener('DOMContentLoaded', this.setupXR, { signal: this.events.signal });
          queueMicrotask(() => {
            if (this.isConnected) this.setupXR();
          });
        }

        disconnectedCallback() {
          this.events?.abort();
          this.requestNumber = (this.requestNumber || 0) + 1;
          this.pending = false;
        }

        async openModel() {
          if (this.pending) return;
          const requestNumber = ++this.requestNumber;
          const error = this.querySelector('.product-ar-cta__error');
          const status = this.querySelector('[data-product-3d-status]');
          const buttons = this.querySelectorAll('[data-product-3d-open]');
          this.pending = true;
          this.setAttribute('aria-busy', 'true');
          error.hidden = true;
          status.textContent = this.dataset.loadingMessage;
          buttons.forEach((button) => { button.disabled = true; });
          let timer;
          try {
            await Promise.race([
              Promise.all([customElements.whenDefined('media-gallery'), customElements.whenDefined('product-model')]),
              new Promise((resolve, reject) => { timer = setTimeout(() => reject(new Error('Model controls unavailable')), 4000); }),
            ]);
            if (!this.isConnected || requestNumber !== this.requestNumber) return;
            const gallery = document.getElementById(`MediaGallery-${this.dataset.sectionId}`);
            const mediaId = `${this.dataset.sectionId}-${this.dataset.modelId}`;
            const media = gallery?.querySelector(`[data-media-id="${mediaId}"]`);
            const productModel = media?.querySelector('product-model');
            if (!gallery || !media || !productModel || typeof gallery.setActiveMedia !== 'function') {
              throw new Error('Model gallery unavailable');
            }
            if (!media.classList.contains('is-active')) {
              gallery.setActiveMedia(mediaId, false);
            } else if (!productModel.hasAttribute('loaded')) {
              productModel.loadContent(false);
            }
            const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            media.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
            const viewer = productModel.querySelector('model-viewer');
            if (viewer) viewer.focus({ preventScroll: true });
            status.textContent = this.dataset.readyMessage;
          } catch (failure) {
            if (this.isConnected && requestNumber === this.requestNumber) {
              error.hidden = false;
              status.textContent = '';
            }
          } finally {
            clearTimeout(timer);
            if (requestNumber === this.requestNumber) {
              this.pending = false;
              this.removeAttribute('aria-busy');
              buttons.forEach((button) => { button.disabled = false; });
            }
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
